<div class="spinner-border text-warning" role="status">

</div>
<h3>Cargando...</h3>